import React from "react";

const ClearerSkinFacialExpect = () => {
  return (
    <div className="blogBenefits-content">
      <h3>What to Expect During an Acne Cure Facial</h3>
      <p>
        First-time clients often wonder what the process feels like. Here's a
        step-by-step outline of what to expect during an Acne Cure Facial:
      </p>
      <li>
        <h6> 1. Consultation</h6>
        <p>
          Your esthetician will assess your skin type, discuss your concerns,
          and identify the best treatment plan for you.
        </p>
      </li>
      <li>
        <h6>2. Preparation</h6>
        <p>
          The facial begins with gentle cleansing and steaming to open up your
          pores, making it easier to extract impurities.
        </p>
      </li>
      <li>
        <h6>3. Treatment</h6>
        <p>
          Each step, from exfoliation to extraction and mask application, is
          tailored to address your specific acne issues. The process is usually
          painless, though some extractions might feel slightly uncomfortable.
        </p>
      </li>
      <li>
        <h6>4. Final Touch</h6>
        <p>
          Your skin is treated with hydrating serums, sunscreen, and other
          finishing products to protect it after the facial.
        </p>
      </li>
    </div>
  );
};

export default ClearerSkinFacialExpect;
